export default {
    getIsPaymentSetup: state => state.isPaymentSetup
}